import { useQuery } from 'react-query';

import { getSubProgramPreferencePartialCompletion as queryFn } from 'api/endPoints/getSubProgramPreferencePartialCompletion';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetSubProgramPreferencePartialCompletion = (params: QueryParams) => {
    return useQuery<Boolean, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getSubProgramPreferencePartialCompletion', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.subProgramId) && Boolean(params.enabled),
        select: (data) => {
            return data ? 'true' : 'false';
        },
    });
};

export interface QueryParams {
    subProgramId?: number;
    enabled?: boolean;
}

export type QueryResponse = 'true' | 'false';
